<template>
    <div>
        <input class="display-none" type="text" v-model="refeshidentiy" />
        <span class="PermissionContentSection">Account Contact Roles</span>
        <div class="row justify-content-start">
            <div class="col-4" v-for="accountContactRole in accountContactRoleList"
                 :key="accountContactRole.roleName">
                <div class="form-check">
                    <label class="form-check-label">
                        <input type="checkbox" class="form-check-input"
                               :value="accountContactRole.roleName"
                               v-model="accountContactRole.roleAccess"
                               @click="CheckAccountContactRole(accountContactRole)" />
                        {{accountContactRole.roleName}}
                    </label>
                    <img src="../../assets/img/icon_info.png"
      :title="accountContactRole.roleHelpText"
      :alt="accountContactRole.roleHelpText"
      class="role-help-icon" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AccountContactRole",

        props: {
            accountContactRoles: Array
        },

        data() {
            return {
                accountContactRoleList: this.accountContactRoles,
                accountContactRoleCheck: [],
                isRoleEdited: false,
                refeshidentiy: 0,
                rolecopy: JSON.stringify(this.accountContactRoles)
            };
        },

        watch: {
            accountContactRoles: function (newVal) {
                this.accountContactRoleList = newVal;
                this.rolecopy = JSON.stringify(newVal);
            }
        },

        methods: {
            isRoleDirty: function () {
                var rolechange = JSON.stringify(this.accountContactRoles);
                return !(rolechange == this.rolecopy);
            },
            CheckAccountContactRole: function (role) {
                var that = this;

                that.accountContactRoleList.find(function (item) {
                    if (role.roleName == item.roleName) {
                        item.roleAccess = !item.roleAccess;
                        that.isRoleEdited = !that.isRoleEdited;
                    }
                });
                that.refeshidentiy++;
            },
            GetAccountContactRoles: function () {
                var that = this;
                that.accountContactRoleCheck = [];
                that.accountContactRoleList.forEach(function (item) {
                    if (item.roleAccess == true) {
                        that.accountContactRoleCheck.push(item.roleName);
                    }
                });
                return that.accountContactRoleCheck;
            }
        }
    };
</script>

<style scoped>
    .role-help-icon {
        font-size: 0.8rem;
        color: black;
        margin-left: 0.3em;
        margin-right: 1.5em;
    }
</style>

